var _g, _path, _g2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecretSticker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2045_2070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 777.164,
    y: 281.825,
    width: 65.9128,
    height: 60.7767,
    transform: "rotate(-0.922495 777.164 281.825)",
    fill: "#D2FF72"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808.978 315.941C808.978 314.978 809.299 314.047 809.941 313.15C810.583 312.252 811.596 311.222 812.981 310.059C814.366 308.829 815.295 307.882 815.768 307.217C816.24 306.552 816.477 305.771 816.477 304.874C816.477 303.711 816.072 302.747 815.261 301.982C814.484 301.218 813.521 300.836 812.373 300.836C810.076 300.836 808.438 302.265 807.458 305.123L803 303.229C803.709 300.902 804.891 299.124 806.546 297.894C808.235 296.631 810.245 296 812.576 296C815.21 296 817.44 296.814 819.264 298.443C821.088 300.038 822 302.049 822 304.475C822 305.904 821.645 307.217 820.936 308.413C820.226 309.577 819.078 310.84 817.49 312.202C816.038 313.465 815.075 314.396 814.602 314.994C814.129 315.559 813.893 316.191 813.893 316.889C813.893 317.287 813.96 317.736 814.096 318.235L809.536 318.235C809.164 317.404 808.978 316.639 808.978 315.941ZM809.181 328.903C808.438 328.172 808.066 327.258 808.066 326.161C808.066 325.065 808.438 324.151 809.181 323.419C809.958 322.655 810.904 322.273 812.018 322.273C813.133 322.273 814.062 322.638 814.805 323.37C815.582 324.101 815.97 325.031 815.97 326.161C815.97 327.258 815.582 328.172 814.805 328.903C814.062 329.634 813.133 330 812.018 330C810.904 330 809.958 329.634 809.181 328.903Z",
    fill: "#42C7F1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2045_2070)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 809.278,
    cy: 281.803,
    r: 2.56803,
    transform: "rotate(6.51456 809.278 281.803)",
    fill: "#FFA800"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 809.278,
    cy: 281.803,
    r: 1.71202,
    transform: "rotate(6.51456 809.278 281.803)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2045_2070",
    x: 773.164,
    y: 280.764,
    width: 74.8828,
    height: 69.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2045_2070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2045_2070",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2045_2070",
    x: 803.709,
    y: 277.235,
    width: 11.1362,
    height: 11.1365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498333 0 0 0 0 0.291667 0 0 0 0 0.625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2045_2070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2045_2070",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretSticker);
export default __webpack_public_path__ + "static/media/SecretSticker.cd26f2adad150ade9ae50d77aa879e0b.svg";
export { ForwardRef as ReactComponent };